import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import general from "./general/reducer";
import provider from "./provider/reducer";
import subjects from "./subjects/reducer";

const appReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    general,
    provider,
    subjects,
    form: formReducer,
  });

// Setup root reducer
const rootReducer = (history) => {
  return appReducer(history);
};

export default rootReducer;
